export const RANGE_META_FIELD = {
  MIN: 3,
  MAX: 99,
};
